// extracted by mini-css-extract-plugin
module.exports = {"container":"v_k","inner":"v_l","right":"v_bM","left":"v_bN","logo":"v_bP","menu":"v_bQ","animationMarquee":"v_j"};